module.exports = __webpack_public_path__ + "static/x86-xsyd.1b7c5e90.png";